// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__rKXMY","text":"Loader_text__3xTJO"};